export default function isEditingElement() {
  const activeTagName = document?.activeElement?.tagName.toLowerCase();
  const tags = ["input", "select", "textarea"];
  return tags.some((tag) => tag === activeTagName);
}
